import { render, staticRenderFns } from "./profile-index.vue?vue&type=template&id=668e80d8&scoped=true&"
import script from "./profile-index.vue?vue&type=script&lang=js&"
export * from "./profile-index.vue?vue&type=script&lang=js&"
import style0 from "./profile-index.vue?vue&type=style&index=0&id=668e80d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668e80d8",
  null
  
)

export default component.exports